import styled from 'styled-components';

export const Text = styled.div`
  text-align: center;
  padding: 0 15%;
  h3,
  p {
    margin-bottom: 15px;
  }
`;

export const Image = styled.img`
  width: 15%;
`;
